/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { cloneElement, useEffect, type ReactElement } from 'react';

import { logEventAsArray } from '@/common/utils/log-events';
import type { TAnalyticArgs } from '@/common/types/analytics.type';

interface AnalyticsWrapperProps {
  analytics: TAnalyticArgs;
  isPageLog?: boolean;
  children: ReactElement;
}

function AnalyticsWrapper({
  children,
  analytics,
  isPageLog,
}: AnalyticsWrapperProps) {
  useEffect(() => {
    if (isPageLog) {
      logEventAsArray(analytics);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPageLog]);

  if (isPageLog) {
    return children;
  }

  const handleClick = (event: MouseEvent) => {
    logEventAsArray(analytics);
    children?.props.onClick?.(event);
  };

  if (children && analytics) {
    return cloneElement(children, {
      onClick: handleClick,
    });
  }
}

export default AnalyticsWrapper;
